export const getAffiliateMap = ({ affiliates, existingAffiliateIds }) => {
  const affiliateMap = {};
  affiliates.forEach(({ affiliate_id, affiliate }) => {
    if (existingAffiliateIds.includes(affiliate_id)) {
      affiliateMap[affiliate_id] = affiliate;
    }
  });
  return affiliateMap;
};
